import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ProtectedRoute } from "./auth/ProtectedRoute";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import SetPassword from "./pages/SetPassword";
import Home from "./pages/Home";
import Profile from "./pages/Profile";
import NotFound from "./pages/NotFound";
import Terms from "./pages/others/Terms";
import Faq from "./pages/others/Faq";
import Help from "./pages/others/Help";
import Header from "./components/Header";
import AuthSessionProvider from "./auth/AuthSessionProvider";

// Wrapper that puts the top bar on every authenticated page.
const Shell: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <AuthSessionProvider>
    <Header />
    <main>{children}</main>
  </AuthSessionProvider>
);

const App = () => (
  <Routes>
    {/* Public */}
    <Route path="/login" element={<Login />} />
    <Route path="/auth-reset" element={<ForgotPassword />} />
    <Route path="/setPassword" element={<SetPassword />} />
    {/* Public legal/help pages — opened from the login footer (AuthFooter). */}
    <Route path="/auths/terms" element={<Terms />} />
    <Route path="/auths/faq" element={<Faq />} />
    <Route path="/auths/help" element={<Help />} />

    {/* Authenticated */}
    <Route element={<ProtectedRoute />}>
      <Route path="/" element={<Navigate to="/home" replace />} />
      <Route
        path="/home"
        element={
          <Shell>
            <Home />
          </Shell>
        }
      />
      <Route
        path="/profile"
        element={
          <Shell>
            <Profile />
          </Shell>
        }
      />
    </Route>

    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default App;
